"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const victory_1 = require("victory");
const plot_1 = require("../plot");
const colors_1 = require("../colors");
const theme_1 = require("@atlaskit/theme");
const theme_2 = require("../../theme");
const { gridSize } = require("@atlaskit/theme");
const GUTTER = gridSize() * 2;
class Legend extends React.Component {
    render() {
        const { data, orientation } = this.props;
        return (React.createElement(theme_2.ThemeContextConsumer, null, ({ mode }) => {
            const textColor = mode === "light" ? theme_1.colors.N800 : theme_1.colors.DN800;
            const style = {
                border: { stroke: textColor },
                title: { fontFamily: plot_1.FONT_FAMILY, fontSize: 18, fill: textColor },
                labels: { fontFamily: plot_1.FONT_FAMILY, fontSize: 12, fill: textColor }
            };
            return (React.createElement(victory_1.VictoryLegend, Object.assign({}, this.props, { centerTitle: true, gutter: GUTTER, orientation: orientation, style: style, colorScale: data.map((datum, index) => datum.symbol && datum.symbol.fill
                    ? datum.symbol.fill
                    : colors_1.colors[index % colors_1.colors.length]) })));
        }));
    }
}
exports.Legend = Legend;
Legend.defaultProps = {
    x: 250,
    y: 0
};
